export default "__VITE_ASSET__B4SMZ9Wq__"